/**
 * MonoLabel — the eyebrow / metadata label used across the Claude Design
 * handoff (Add Building flow, dashboard sections, building detail).
 *
 * Anatomy:
 *   - JetBrains Mono, font-size 10px, letter-spacing 1.2, uppercase
 *   - color: ink/mute (#737373) by default
 *
 * Source: /tmp/design-handoff/carbon-clear/project/add-building-flow.jsx
 * (`MonoLabel` function — lines 34-41). Hex values come from the design's
 * 60/30/10 palette tokens; do NOT approximate via the existing Tailwind
 * `text-muted-foreground` because that doesn't render at the same color.
 *
 * Examples:
 *   <MonoLabel>Step 1 of 2 · Locate</MonoLabel>
 *   <MonoLabel>Portfolio · May 2026</MonoLabel>
 *   <MonoLabel className="mb-3">4 matches in NYC records</MonoLabel>
 */
import React from "react";
import { cn } from "@/lib/utils";

interface MonoLabelProps extends React.HTMLAttributes<HTMLDivElement> {
  as?: "div" | "span" | "p";
}

const MonoLabel: React.FC<MonoLabelProps> = ({
  as: Tag = "div",
  className,
  children,
  ...rest
}) => (
  <Tag
    className={cn(
      "font-mono text-[10px] uppercase tracking-[1.2px] text-ink-mute leading-none",
      className,
    )}
    {...rest}
  >
    {children}
  </Tag>
);

export default MonoLabel;
